import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import { informationChannelEnum } from "../../../../shared/selectors/informationChannelEnum";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { customStyles } from "../custom-selector-styles";
import { ErrorMessage } from "formik";
import { validateDocumentReferred } from "../../../../shared/helpers/validateFields";
import { InformationChannel } from "../../../../shared/model/enumerations/information-channel.model";
interface IProps {
  formik: any;
}
const animatedComponents = makeAnimated();
export const Others = (props: IProps) => {
  const { formik } = props;

  return (
    <>
      {/* OTHERS */}
      <Row className="title-form not-first-title">Otros</Row>
      <Row className="container-inputs-form">
        <Col md="6">
          <FormGroup>
            <Label>A través de que medio te enteraste de la propuesta</Label>
            <Select
              name={`candidateToApplications[${0}].informationChannel`}
              placeholder={placeholderSelectSimple()}
              noOptionsMessage={() => placeholderNoOptions()}
              components={animatedComponents}
              isClearable
              options={informationChannelEnum()}
              value={to_ISelect_Enum(
                formik.values.candidateToApplications[0].informationChannel,
                informationChannelEnum()
              )}
              onChange={(e: any) => {
                formik.setFieldValue(
                  `candidateToApplications[${0}].informationChannel`,
                  e?.value ? e.value : null
                );
                if (e?.value && e.value !== InformationChannel.KNOWN_REFERRED) {
                  formik.setFieldValue(`referreds[${0}]`, {});
                }
              }}
              onBlur={formik.handleBlur(
                `candidateToApplications[${0}].informationChannel`
              )}
              className={`select-postulate`}
              styles={customStyles}
            />
          </FormGroup>
        </Col>
      </Row>
      {formik.values?.candidateToApplications[0]?.informationChannel &&
        formik.values?.candidateToApplications[0]?.informationChannel ===
          InformationChannel.KNOWN_REFERRED && (
          <>
            <Row className="container-inputs-form">
              <Col>
                <FormGroup>
                  <Label>Nombre de referente</Label>
                  <Input
                    type="text"
                    name={`referreds[${0}].name`}
                    onChange={formik.handleChange(`referreds[${0}].name`)}
                    onBlur={formik.handleBlur(`referreds[${0}].name`)}
                    value={formik.values.referreds[0].name || ""}
                    placeholder={placeholderText()}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label>Apellido de referente</Label>
                  <Input
                    type="text"
                    name={`referreds[${0}].lastname`}
                    onChange={formik.handleChange(`referreds[${0}].lastname`)}
                    onBlur={formik.handleBlur(`referreds[${0}].lastname`)}
                    value={formik.values.referreds[0].lastname || ""}
                    placeholder={placeholderText()}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="container-inputs-form">
              <Col md="6">
                <FormGroup>
                  <Label>DNI de referente</Label>
                  <Input
                    type="text"
                    name={`referreds[${0}].document`}
                    onChange={formik.handleChange(`referreds[${0}].document`)}
                    onBlur={formik.handleBlur(`referreds[${0}].document`)}
                    value={formik.values.referreds[0].document}
                    placeholder={placeholderText()}
                    className={
                      validateDocumentReferred(formik, 0) ? "is-invalid" : ""
                    }
                  />
                  <div className="invalid-feedback">
                    <ErrorMessage name={`referreds[${0}].document`} />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </>
        )}
    </>
  );
};
